import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import {
  RowLayoutWidgetFields,
  RowLayoutWidgetFormFields,
  validLayoutWidgetItemTypes,
  validateRowLayoutWidgetFormFields,
} from 'components/consumer-page-widgets/row-layout-widget/RowLayoutWidgetFormFields';
import { StoreType } from 'utils/connect';
import { Widgets } from '@tock/shared/types/widget';
import { consumer } from '@tock/coretypes';
import { fetchAllNamedConfigurations } from 'actions/ConsumerPageActions';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import { useAppDispatch } from 'state/hooks';
import { useSelector } from 'react-redux';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface CreateRowLayoutWidgetFormProps {
  onCompleteOrCancel(): void;
}

export const CreateRowLayoutWidgetForm: FunctionComponent<
  React.PropsWithChildren<CreateRowLayoutWidgetFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchAllNamedConfigurations());
  }, [dispatch]);

  const activeNamedConfigs = useSelector(
    (state: StoreType) => state.consumerPage.namedConfigurations
  ) as consumer.NamedConfiguration[]; // TODO: Fix types on consumerPage state slice

  const widgetsFilteredForSelectedType = activeNamedConfigs.filter((config) => {
    return (
      config.namedConfigurationConfig &&
      validLayoutWidgetItemTypes.includes(config.namedConfigurationConfig)
    );
  });

  const handleSubmit = ({
    name,
    namedConfigurationIdLeft,
    widthPercentageLeft,
    namedConfigurationIdRight,
    widthPercentageRight,
  }: RowLayoutWidgetFields) => {
    return createNamedConfig({
      name: name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      rowLayoutWidgetConfig: {
        rowLayoutWidgetItemConfig: [
          {
            namedWidgetConfigurationId: namedConfigurationIdLeft,
            widthPercentage: widthPercentageLeft,
          },
          {
            namedWidgetConfigurationId: namedConfigurationIdRight,
            widthPercentage: widthPercentageRight,
          },
        ],
      },
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik<RowLayoutWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
          namedConfigurationIdLeft: undefined,
          widthPercentageLeft: 50,
          namedConfigurationIdRight: undefined,
          widthPercentageRight: 50,
        }}
        validate={validateRowLayoutWidgetFormFields}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <RowLayoutWidgetFormFields namedConfigurations={widgetsFilteredForSelectedType} />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
